import React from 'react';
import { showHintPositions} from '../helpers/cameraPositions';

export default function CameraPositionSetter({ camera , newCameraPosition, setNewCameraPosition, defaultPosition, canvasId, glbPath}) {
  const newPosition = (canvasId === 'wrongViewModelCanvas') ? showHintPositions[glbPath] || { x: 0, y: 194, z: -461 } : defaultPosition; // デフォルト位置を定義
    const handleClick = () => {
      // 常に状態を更新して `useThreeRenderer` 側の effect を発火させる
        // 状態のみ更新して、`useThreeRenderer` のアニメーションに任せる
        setNewCameraPosition(newPosition);
        if (!camera) {
          console.warn('Camera not ready (will be applied when renderer initializes)');
        }
  };

  return (
    <button 
        onClick={handleClick}
        className="btn btn--small btn--primary"
        >目線を元に戻す
    </button>
  );
}
